module.exports = __webpack_public_path__ + "img/verification.a6376088.svg";